





import Vue from 'vue'
export default Vue.extend({
  props: {
    block: {},
    scope: {},
    options: {}
  }
})
